import { createRouter, createWebHistory } from 'vue-router';
import EntryPage from '@/components/EntryPage.vue';
import NCodeMetricsComponent from '@/components/NCodeMetrics.vue';
import MainComponent from '@/components/MainComponent.vue';

const routes = [
  {
    path: '/',
    name: 'entry',
    component: EntryPage
  },
  {
    path: '/ncode',
    name: 'NCodeMetrics',
    component: NCodeMetricsComponent,
  },
  {
    path: '/copilot',
    name: 'Copilot',
    component: MainComponent
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});


export default router; 